import React from 'react'
import { Modal } from 'antd'

interface InfoModalProps {
  isVisible: boolean
  title?: string
  description?: string
  onOk: () => void
  onCancel: () => void
}

export default function InfoModal(props: InfoModalProps) {
  const TitleElement = <div className="mt-4 text-center text-xl font-bold text-black md:text-2xl">{props.title}</div>

  return (
    <Modal
      title={TitleElement}
      style={{ top: 20 }}
      open={props.isVisible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      footer={false}
      bodyStyle={{ padding: 4 }}
      centered
    >
      <p className="mx-0 my-0 text-center text-xl md:mx-2 md:my-4">{props.description}</p>
      <div className="grid w-full justify-items-center md:m-4">
        <button
          onClick={props.onCancel}
          className={`mt-3 w-1/5 rounded bg-blue-500 px-3 py-2 text-base text-white md:rounded-md`}
        >
          OK
        </button>
      </div>
    </Modal>
  )
}
